<script setup lang="ts">
import { computed } from "vue";
import { useFormattedCurrency } from "~/composables/useFormattedCurrency";

export interface FormattedCurrencyProps {
  currency?: string;
  currencyDisplay?: "symbol" | "narrowSymbol" | "code" | "name";
  locale?: string;
  precision?: number;
  showPositivePrefix?: boolean;
  value: number | string;
}

const props = defineProps<FormattedCurrencyProps>();

const formattedValue = computed(() => {
  const { formattedValue } = useFormattedCurrency(props.value, props);
  return formattedValue;
});
</script>

<template>{{ formattedValue }}</template>
